
import firebase from 'firebase'
import 'firebase/firestore'

 
var firebaseConfig = {
    apiKey: "AIzaSyBiW1k-ToAq_2yJyLzuJMSDSaCBaZ-viGs",
    authDomain: "prome-muhendislik-hosting.firebaseapp.com",
    databaseURL: "https://prome-muhendislik-hosting.firebaseio.com",
    projectId: "prome-muhendislik-hosting",
    storageBucket: "prome-muhendislik-hosting.appspot.com",
    messagingSenderId: "786956715168",
    appId: "1:786956715168:web:f02ec31295db35a417b5c5",
    measurementId: "G-M1STLTMQC3"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  const db=firebase.firestore()

  export default firebase